import type { components as definitions } from "@securityjourney/svc-chores/dist/gen/chores.d.ts";
import type { ChoreList } from "../client/svcChores";

type ChoreItem = ChoreList["items"][number];
type Lesson = definitions["schemas"]["securityjourney.proto.chores.Lesson"];

export type LessonChoreItem = ChoreItem & {
  content: { lesson: Lesson };
};

export interface PersonalizedLessonAssignment {
  name: string;
  description: string;
  dueDate: { days?: number } | undefined;
  totalLessons: number;
  completedLessons: number;
  progressPercent: number;
  completed: LessonChoreItem[];
  notCompleted: LessonChoreItem[];
}

function isLessonItem(item: ChoreItem): item is LessonChoreItem {
  return "lesson" in item.content;
}

export function getPersonalizedLessonAssignment(
  choreItems: ChoreList["items"] | undefined
): PersonalizedLessonAssignment | null {
  const lessons = choreItems?.filter(isLessonItem) ?? [];
  if (!lessons.length) return null;

  const completed: LessonChoreItem[] = [];
  const notCompleted: LessonChoreItem[] = [];
  lessons.forEach(item => {
    if (item.content.lesson.status.progress === "Completed") {
      completed.push(item);
    } else {
      notCompleted.push(item);
    }
  });

  const totalLessons = lessons.length;
  const completedLessons = completed.length;
  const progressPercent = totalLessons ? Math.round((completedLessons / totalLessons) * 100) : 0;

  return {
    name: lessons[0].listing.title,
    description: lessons[0].listing.description,
    dueDate: lessons[0].schedule.dates?.dueAfter,
    totalLessons,
    completedLessons,
    progressPercent,
    completed,
    notCompleted,
  };
}
